import Head from "next/head";

export function ProductMetadata({ slug, imagePath, translations }) {
	const metadata = translations?.products?.[slug]?.metadata;

	return (
		<Head>
			{/* <!-- Primary Meta Tags --> */}
			<title>{metadata?.title}</title>
			<meta name="title" content={metadata?.metaTitle} />
			<meta name="description" content={metadata?.metaDescription} />

			{/* <!-- Open Graph / Facebook / Instagram --> */}
			<meta property="og:type" content="website" />
			<meta property="og:url" content={imagePath} />
			<meta property="og:title" content={metadata?.metaTitle} />
			<meta property="og:description" content={metadata?.metaDescription} />
			<meta property="og:image" content={imagePath} />

			{/* <!-- LinkedIn --> */}
			<meta property="twitter:card" content="summary_large_image" />
			<meta property="twitter:url" content={imagePath} />
			<meta property="twitter:title" content={metadata?.metaTitle} />
			<meta
				property="twitter:description"
				content={metadata?.metaDescription}
			/>
			<meta property="twitter:image" content={imagePath} />
			{/* Make your website shareable on LinkedIn */}
		</Head>
	);
}
